module.exports = __webpack_public_path__ + "img/oops-bluetooth.5171ed23.svg";